import { Navigate } from 'react-router-dom'
import { useAuthUser } from '@BUP/services/auth/use-auth-user.jsx'

export default function AuthenticatedRoute ({ children }) {
  const authUser = useAuthUser()
  if (!authUser) return <Navigate to='/login' />

  return children
}
